import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    // {
    //   path: '/resume',
    //   name: 'resume',
    //   component: () => import('../views/ResumeView.vue'),
    //   meta: {
    //     title: 'Juan Lias - Resume',
    //   },
    // },
    // {
    //   path: '/weather-test',
    //   name: 'weather-test',
    //   component: () => import('../components/landingFolio/WeatherCardTest.vue'),
    //   meta: {
    //     title: 'Weather Card Test - Juan Lias',
    //   },
    // },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('../views/NotFoundView.vue'),
      meta: {
        title: 'Page Not Found',
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0, behavior: 'smooth' }
  },
})

// Guard para actualizar el título de la página
router.beforeEach((to, from, next) => {
  if (to.meta?.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
